module.exports = __webpack_public_path__ + "img/success.08b5b690.png";